export default "__VITE_ASSET__CXZKvd3u__"